import React, { useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap'
import { appName } from 'consts'
import Header from 'shared/containers/Header'
import getCurrentPage from 'shared/utils/getCurrentPage'
import getPageByPath from 'shared/utils/getPageByPath'
import Page from 'shared/types/Page'

interface WrapperProps {
    headerInsert?: React.FunctionComponent | React.ReactElement | false
    actionInsert?: React.FunctionComponent | React.ReactElement | false
    footerContent?: React.FunctionComponent | React.ReactElement | string | false
    showCardHeader?: boolean
    noCard?: boolean
    pageTitle?: string
    menuBottomInsert?: React.FunctionComponent | React.ReactElement | string | false
}

const ContentWrapper: React.FunctionComponent<WrapperProps> = (props) => {

    const { children } = props
    const [pageTitle, setPageTitle] = useState('')
    const [addLink, setAddLink] = useState<string | undefined>(undefined)
    const [addLinkRoles, setAddLinkRoles] = useState<String[] | undefined>(undefined)
    let curLoc = useLocation()


    useEffect(() => {
        if(props.pageTitle){
            setPageTitle(props.pageTitle)
        }
    }, [props.pageTitle])

    useEffect(() => {

        // set page title
        getCurrentPage(curLoc).then((curPage) => {

            let pageTitle = props.pageTitle ? props.pageTitle : (curPage && curPage.name) ? curPage.name : ''
            setPageTitle(pageTitle)

            if (curPage && (pageTitle.length > 0)) {

                if (typeof curPage.parentPath !== 'undefined') {
                    const parentPage = getPageByPath(curPage.parentPath)
                    if (parentPage) {
                        pageTitle = parentPage.name + ' / ' + pageTitle
                    }
                }

                if (curPage.addLink !== undefined) {
                    setAddLink(curPage.addLink)

                    const addPage: Page | null = getPageByPath(curPage.addLink)
                    if (addPage?.roles !== undefined) {
                        setAddLinkRoles(addPage.roles)
                    }

                }

                const title = curPage.name + ' | ' + appName
                document.title = title
            }
        })
    }, [curLoc])

    return (
        <main className="main-panel">
            <Header title={pageTitle} addLink={addLink} addLinkRoles={addLinkRoles} headerInsert={props.headerInsert} menuBottomInsert={props.menuBottomInsert} />

            <div className="content">
                <Row>
                    <Col md="12">
                        {!props.noCard && <Card>
                            {props.showCardHeader && <CardHeader className='main'>
                                <h4>{pageTitle}</h4>
                                {props.actionInsert ? <div className='action-insert'>{props.actionInsert}</div> : ''}
                            </CardHeader>}
                            <CardBody>
                                {children}
                            </CardBody>
                        </Card>}
                        {props.noCard && children}
                    </Col>
                </Row>
                {props.footerContent}
            </div>
        </main>
    );
}

export default ContentWrapper